// Considered: ad-hoc `.detail-row` patterns in TaskCard, UserList, NodeLabel — rejected because
// no atom exists for a fixed-width label / 700-weight value pair; those are exactly the sibling
// proliferation this atom ends. See spec Reuse Audit (specs/stream-trajectory-tools.md).
//
// Source: design/metaspace-tools/metaspace-interactions.jsx `KV`.

import React from 'react';
import './KeyValueRowAtom.scss';

export interface KeyValueRowAtomProps {
  label: React.ReactNode;
  value: React.ReactNode;
  /** Renders `value` in the mono font at a slightly smaller size — timestamps, ids, enum literals. */
  mono?: boolean;
  className?: string;
}

const KeyValueRowAtom: React.FC<KeyValueRowAtomProps> = ({ label, value, mono = false, className }) => (
  <div className={['key-value-row-atom', className].filter(Boolean).join(' ')}>
    <span className="key-value-row-atom__label">{label}</span>
    <span
      className={
        mono ? 'key-value-row-atom__value key-value-row-atom__value--mono' : 'key-value-row-atom__value'
      }
    >
      {value}
    </span>
  </div>
);

KeyValueRowAtom.displayName = 'KeyValueRowAtom';

export default KeyValueRowAtom;
